import { Link } from "react-router-dom";
import { CheckCircle2, Copy, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";

const CodeBox = ({ label, value, testId }) => (
  <div className="flex items-center justify-between rounded-lg border border-dashed border-slate-300 bg-slate-50 px-4 py-3">
    <div className="text-left">
      <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">{label}</p>
      <p className="font-mono text-lg font-semibold tracking-wider" data-testid={testId}>{value}</p>
    </div>
    <button type="button" aria-label="Copier" data-testid={`${testId}-copy`}
      onClick={() => { navigator.clipboard.writeText(value); toast.success("Copié"); }}><Copy className="h-4 w-4 text-slate-500" /></button>
  </div>
);

export default function SubmissionSuccess({ result, loggedIn }) {
  const link = `${window.location.origin}/suivi?code=${result.tracking_code}#token=${result.access_token}`;
  return (
    <div data-testid="feedback-success" className="card-surface rise p-6 text-center sm:p-8">
      <CheckCircle2 className="mx-auto h-10 w-10 text-emerald-600" />
      <h2 className="mt-4 font-display text-xl font-bold">Merci, votre message a bien été enregistré</h2>
      <p className="mt-2 text-sm text-slate-500">
        {result.visibility === "public"
          ? "Votre avis sera publié après validation par l'organisation. Vos coordonnées ne sont jamais publiées."
          : "Votre message est privé : seule l'organisation concernée peut le lire."}
      </p>
      <div className="mx-auto mt-6 max-w-sm space-y-2">
        <CodeBox label="Numéro de référence" value={result.tracking_code} testId="feedback-tracking-code" />
        <CodeBox label="Code secret" value={result.pin} testId="feedback-pin" />
        <div className="flex items-center justify-between gap-2 rounded-lg border border-dashed border-slate-300 bg-slate-50 px-4 py-3 text-left">
          <div className="min-w-0"><p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Lien d'accès privé</p>
            <p className="truncate font-mono text-xs" data-testid="feedback-access-link">{link}</p></div>
          <button type="button" aria-label="Copier le lien" data-testid="feedback-access-link-copy" onClick={() => { navigator.clipboard.writeText(link); toast.success("Lien copié"); }}><Copy className="h-4 w-4 text-slate-500" /></button>
        </div>
      </div>
      <p className="mx-auto mt-4 flex max-w-sm items-start gap-2 rounded-lg bg-amber-50 px-3 py-2 text-left text-xs text-amber-900">
        <KeyRound className="mt-0.5 h-3.5 w-3.5 shrink-0" /> Notez ces codes ou conservez le lien privé maintenant : ils ne seront plus jamais affichés. La référence seule ne permet pas d'accéder à votre dossier.
      </p>
        {result.sensitive && <p className="mx-auto mt-3 max-w-sm rounded-lg bg-rose-50 px-3 py-2 text-left text-xs text-rose-800" data-testid="feedback-sensitive-note">Votre signalement est traité en priorité et de façon confidentielle.</p>}
      <div className="mt-6 flex flex-wrap justify-center gap-2">
        {loggedIn && <Button asChild className="rounded-full" data-testid="feedback-open-my-space"><Link to={`/mon-espace/feedbacks/${result.id}`}>Voir dans mon espace</Link></Button>}
        <Button asChild variant={loggedIn ? "outline" : "default"} className="rounded-full" data-testid="feedback-track-link"><Link to={`/suivi?code=${result.tracking_code}`}>Suivre mon dossier</Link></Button>
      </div>
    </div>
  );
}
